<template>
  <v-menu
      offset-y
      offset-overflow
      v-model="pickerOpen"
      :close-on-content-click="false"
      max-width="290px"
      min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
          ref="textField"
          :rules="textRules"
          :error-messages="errors"
          v-model="fechaFormatted"
          @blur="blurFechaFormated"
          @keydown="$emit('keydown', $event)"
          @keyup="$emit('keyup', $event)"
          v-mask="'##/##/####'"
          return-masked-value
          :label="label"
          hint="Formato DD/MM/AAAA"
          validate-on-blur
          v-on="on"
          @keydown.tab="closePicker"
      ></v-text-field>
    </template>
    <v-date-picker
        :value="fecha"
        :min="min"
        :max="max"
        @input="updateFecha($event); closePicker()"
        first-day-of-week="1"
        locale="es-es"
        no-title
    ></v-date-picker>
  </v-menu>
</template>

<script>
  import {mask} from 'vue-the-mask'

  export default {
    name: 'FhDate',
    directives: {mask},
    props: {
      'rules': {type: Array, default: () => []},
      'value': String,
      'label': String,
      'min': String,
      'max': String
    },
    data() {
      return {
        pickerOpen: false,
        // Format: 2018-08-03
        fecha: null,
        // Format: 03/08/2018
        fechaFormatted: null,
        errors: [],
        textRules: this.rules.concat([v => this.ruleIsValidDate(v)])
      }
    },
    watch: {
      value: {
        immediate: true,
        handler(newValue, oldValue){
          // Set initial value
          if (!oldValue || oldValue === '' || oldValue === null) {
            // 2018-08-03T00:00:00 -> 2018-08-03
            if(this.value){
              const fechaCleaned = this.value.split('T')[0]
              this.updateFecha(fechaCleaned)
            }
          }
        }
      }
    },
    methods: {
      ruleIsValidDate(fecha) {
        if (!fecha) {
          return true
        }

        if (!this.isValidDate(this.formatFecha(this.parseFecha(fecha)))) {
          return 'No es una fecha válida'
        } else {
          let fechaDate = new Date(`${this.parseFecha(fecha)}T00:00:00`)
          if ((!!this.min && fechaDate < new Date(this.min)) || (!!this.max && fechaDate > new Date(this.max))) {
            return 'Fecha fuera del rango válido'
          } else {
            return true
          }
        }
      },
      closePicker() {
        this.pickerOpen = false
      },
      blurFechaFormated() {
        const fechaParsed = this.parseFecha(this.fechaFormatted)
        if (this.isValidDate(this.formatFecha(fechaParsed))) {
          this.updateFecha(fechaParsed)
        }
      },
      updateFecha(fecha) {
        this.fecha = fecha
        this.fechaFormatted = this.formatFecha(this.fecha)
        // Validate text field on next tick to show current and not previous error message
        this.$nextTick(function () {
          this.$refs.textField.validate()
        })
        this.$emit('input', this.fecha)
      },
      formatFecha(fecha) {
        if (!fecha) {
          return null
        }

        // 2018-08-03 -> 03/08/2018
        return fecha.split('-').reverse().join('/')
      },
      isValidDate(fechaFormatted) {
        if (!fechaFormatted) {
          return true
        }

        // First check for the pattern (dd/mm/yyyy)
        let regexDate = /^\d{1,2}\/\d{1,2}\/\d{4}$/

        if (!regexDate.test(fechaFormatted)) {
          return false
        }

        // Parse the date parts to integers
        let parts = fechaFormatted.split('/')
        let day = parseInt(parts[0], 10)
        let month = parseInt(parts[1], 10)
        let year = parseInt(parts[2], 10)

        // Check the ranges of month and year
        if (year < 1000 || year > 3000 || month < 1 || month > 12) {
          return false
        }

        let monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]

        // Adjust for leap years
        if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
          monthLength[1] = 29
        }

        // Check the range of the day
        return day > 0 && day <= monthLength[month - 1]
      },
      parseFecha(fecha) {
        /*
        * input: 02/03/2018
        * input: 02/03/18
        * input: 2/3/18
        * input: 02/03
        * input: 02032018
        * input: 020318
        * input: 0203
        * input: 02
        * input: 2
        * output: 2018-03-02
        * output: null
        * */

        const currentDate = new Date()
        let year = currentDate.getFullYear().toString()
        let month = (currentDate.getMonth() + 1).toString()
        let day = currentDate.getDate().toString()

        if (fecha) {
          if (fecha.includes('/')) {
            const splitDate = fecha.split('/')

            // 2/3 or 02/03
            if (splitDate.length === 2) {
              day = splitDate[0]
              // not 02/<empty>
              if (splitDate[1]) {
                month = splitDate[1]
              }

              // 2/3/18 or 02/03/2018
            } else if (splitDate.length === 3) {
              day = splitDate[0]
              month = splitDate[1]
              // not 02/03/<empty>
              if (splitDate[2]) {
                // year 18 or 2018
                if (splitDate[2].length === 2 || splitDate[2].length === 4) {
                  year = splitDate[2]
                } else {
                  // validation error
                  return null
                }
              }
            } else {
              // validation error
              return null
            }

            // date without /
          } else {
            // 2 or 02
            if (fecha.length === 1 || fecha.length === 2) {
              day = fecha

              // 0203
            } else if (fecha.length === 4) {
              day = fecha.slice(0, 2)
              month = fecha.slice(2, 4)

              // 020318 or 02032018
            } else if (fecha.length === 6 || fecha.length === 8) {
              day = fecha.slice(0, 2)
              month = fecha.slice(2, 4)
              year = fecha.slice(4)
            } else {
              // validation error
              return null
            }
          }

          // year 18 -> 2018
          if (year.length === 2) {
            year = '20' + year
          }

          return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        }

        return null
      }
    }
  }
</script>

<style scoped>

</style>
